import store from "@/store";
import {
  getModule,
  Module,
  Mutation,
  MutationAction,
  VuexModule,
  Action,
} from "vuex-module-decorators";

export interface IOrcamentoAutoModule {
  mensagemOficina: string | null;
}

const getDefaultState = () => {
  return {
    mensagemOficina: null
  };
};

@Module({
    namespaced: true,
    dynamic: true,
    store,
    name: "orcamentoAuto",
})
class OrcamentoAutoModule extends VuexModule {
  mensagemOficina: string | null = null;
  
  @Mutation
  RESET() {
    Object.assign(this, getDefaultState());
  }

  @Mutation
  SET_MENSAGEM_OFICINA(payload: string) {
    this.mensagemOficina = payload
  }
}

const orcamentoAutoModule = getModule(OrcamentoAutoModule);
export default orcamentoAutoModule;